export const USER_ID = 'userId';
export const AUTH_TOKEN = 'token';
export const AXIOS_URL = 'https://auth.schoolify.ee';
export const API_URL = process.env.REACT_APP_HASURA_URL;
export const MANAGMENT_API_URL = 'https://management.dev.schoolify.ee/v1/graphql';
